import React, { useState, useEffect } from 'react';
import { Calendar, Bell, Clock, Users } from 'lucide-react';
import { featuresAPI } from '../services/api';

// Icon mapping
const iconMap = {
  Calendar: Calendar,
  Bell: Bell,
  Clock: Clock,
  Users: Users
};

const Features = () => {
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchFeatures();
  }, []);

  const fetchFeatures = async () => {
    try {
      setLoading(true);
      const response = await featuresAPI.getAll();
      setFeatures(response.data || []);
      setError(null);
    } catch (err) {
      console.error('Error fetching features:', err);
      setError('Failed to load features');
      // Keep empty array if fetch fails
      setFeatures([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-light text-gray-800 mb-4">
              How yiBooking Works
            </h2>
            <p className="text-xl text-gray-600">
              Everything you need to manage appointments effortlessly
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="flex flex-col items-center text-center space-y-4 p-8">
                <div className="w-12 h-12 bg-gray-200 animate-pulse rounded-full"></div>
                <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                <div className="w-full h-20 bg-gray-200 animate-pulse rounded"></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light text-gray-800 mb-4">
            How yiBooking Works
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to manage appointments effortlessly
          </p>
        </div>
        
        {error && (
          <div className="text-center text-red-500 mb-8">
            {error}
          </div>
        )}
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon] || Calendar;
            return (
              <div 
                key={feature.id || index} 
                className="flex flex-col items-center text-center space-y-4 p-8 rounded-lg hover:bg-gray-50 transition-all duration-300 group"
              >
                <div className="text-yellow-500 group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="w-12 h-12" />
                </div>
                <h3 className="text-2xl font-semibold text-gray-800">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;